import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from '../services/utility.service';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  lang: string;

    constructor(
        private translate: TranslateService,
        private utilityService: UtilityService,
      
    )
    {
        super();
        this.initLabels();
        this.lang = this.utilityService.getLang();
        this.translate.setDefaultLang(this.lang);
        this.translate.use(this.lang);
        this.translate.onLangChange.subscribe(() => this.initLabels());
    }

    private initLabels(): void {
        this.itemsPerPageLabel = this.translate.instant('PAGINATOR.ITEMS_PER_PAGE');
        this.nextPageLabel = this.translate.instant('PAGINATOR.NEXT_PAGE');
        this.previousPageLabel = this.translate.instant('PAGINATOR.PREVIOUS_PAGE');
        this.firstPageLabel = this.translate.instant('PAGINATOR.FIRST_PAGE');
        this.lastPageLabel = this.translate.instant('PAGINATOR.LAST_PAGE');

        this.getRangeLabel = (page: number, pageSize: number, length: number): string => {
            if (length === 0 || pageSize === 0) {
                return this.translate.instant('PAGINATOR.RANGE', { start: 0, end: 0, total: length });
            }
            const startIndex = page * pageSize;
            const endIndex = Math.min(startIndex + pageSize, length);
            return this.translate.instant('PAGINATOR.RANGE', { start: startIndex + 1, end: endIndex, total: length });
        };

        this.changes.next();
    }
}
